"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTitle = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
exports.StyledTitle = styled_components_1.default.h1 `
  margin: 0;

  font-family: 'ATTAleckSans';
`;
